module.exports = __webpack_public_path__ + "static/media/dinosaur(23).393ba284.PNG";